import React, { useEffect } from 'react'
import { Badge, Button, Col } from 'antd'
import { useLocation, useParams } from 'react-router-dom'
import useNotification from '../../hooks/notification'
import {
  NOTIFICATION_SUBSCRIPTION,
  MOVEAI_COMMENT_CREATED,
  ADD_NEW_COMMENT,
  CREATE_NEW_SUBSCRIPTION,
  CREATE_NEW_EVENTS,
} from '../../services/graphql-subscription/notification/tags'
import { BellFilled, BellOutlined } from '@ant-design/icons'
import '../../css/notification.css'
import { useState, useRef } from 'react'
import _ from 'lodash'
import useToast from '../../hooks/toast'
import { connect } from 'react-redux'
import {
  editcase,
  fechactioncase,
  getMessageCase,
  updateLastViewed,
  isNewActionCase,
} from '../../store/action/actioncases.action'
import {
  isEventUpdated,
  getEvents,
  getDifference,
} from '../../store/action/event.action'
const NotificationBell = (props) => {
  const location = useLocation()

  const [color, setColor] = useState('')
  const notification = useNotification({
    gqltag: NOTIFICATION_SUBSCRIPTION,
    params: { customerId: props.customerId, surgeonId: props.user?.surgeon },
  })

  const moveAiComments = useNotification({
    gqltag: MOVEAI_COMMENT_CREATED,
    params: { companyId: props.companyId },
  })
  const createCase = useNotification({
    gqltag: CREATE_NEW_SUBSCRIPTION,
    params: { customerId: props.customerId, surgeonId: props.user?.surgeon },
  })
  const adminComments = useNotification({
    gqltag: ADD_NEW_COMMENT,
    params: { customerId: props.customerId},
  })
  const { successToast } = useToast()

  // A single new patient message fires more than one subscription (e.g. the
  // MoveAI-comment and new-case-created channels both publish), so several of
  // the handlers below would each pop an identical toast. Collapse duplicates
  // that land within a short window into a single notice.
  const lastToastRef = useRef(0)
  const notifyNewMessage = () => {
    const now = Date.now()
    if (now - lastToastRef.current < 1500) return
    lastToastRef.current = now
    successToast('You have received a new message!')
  }

  // Handle onComment subscription
  useEffect(() => {
    if (!_.isEmpty(notification.notification)) {
      const { onComment } = notification.notification
      if (onComment && onComment?.status) {
        setColor('red')
        notifyNewMessage()
        fetchActionCases()
      }
    }

    return () => {
      if (notification.notification.unsubscribe) notification.unsubscribe()
    }
  }, [notification.notification])

  useEffect(() => {
    if (!_.isEmpty(moveAiComments.notification)) {
      const { moveAiComment } = moveAiComments.notification
      if (moveAiComment && moveAiComment?.status) {
        setColor('red')
        notifyNewMessage()
        fetchMoveAiActionCases()
        // Also refresh the general Cases list — a company admin watching /cases
        // otherwise wouldn't see the new MoveAI message appear live.
        fetchActionCases()
      }
    }

    return () => {
      if (moveAiComments.notification.unsubscribe) moveAiComments.unsubscribe()
    }
  }, [moveAiComments.notification])

  // Handle getActionCaseListSubscription subscription
  useEffect(() => {
    if (!_.isEmpty(createCase.notification)) {
      const { getActionCaseListSubscription } = createCase.notification
      if (getActionCaseListSubscription) {
        notifyNewMessage()
        fetchActionCases()
      }
    }

    return () => {
      if (createCase.notification.unsubscribe) createCase.unsubscribe()
    }
  }, [createCase.notification])

  useEffect(() => {
    if (!_.isEmpty(adminComments.notification)) {
      const { addAdminCommentToLite } = adminComments.notification
      if (addAdminCommentToLite && addAdminCommentToLite?.status) {
        fetchActionCases()
      }
    }
    return () => {
      if (adminComments.notification.unsubscribe) adminComments.unsubscribe()
    }
  }, [adminComments.notification])  
  useEffect(() => {
    if (props.isNew) setColor('red')
    else setColor('')
  }, [props.isNew])

  const handleCaseView = async () => {
    try {
      if (location.pathname?.includes('/cases/')) {
        const caseId = location.pathname?.split('/').pop()
        props.getMessageCase(caseId)
        await props.updateLastViewed({ caseId: caseId })
        await props.isNewActionCase(
          props.customer?._id,
          props.user?.surgeon,
          props?.company?._id
        )
      }
    } catch (error) {
      console.log(error, 'Error in handleCaseView')
    }
  }
  const fetchActionCases = async () => {
    let filter = { archived: false }
    // Customer-scoped users (customer admin / surgeon) filter by their customer.
    // Company & super admins have no selected customer and rely on the backend's
    // role-scoping — the same way the Cases page itself fetches. Previously this
    // bailed when no customer was selected, so a company admin's list never
    // refreshed on a new message (that was the "not real-time" bug).
    if (props?.customer?._id) {
      filter.customerIds = [props.customer._id]
      if (props.user?.surgeon) filter.surgeonId = props.user?.surgeon
    }
    filter = { ...filter, ...props.msgfilter }

    props.fechactioncase({
      metadata: { current: 1, pageSize: 20 },
      filters: filter,
      sorter: { field: 'lastUpdated', order: 'descend' },
    })
    await handleCaseView()
  }

  const fetchMoveAiActionCases = async () => {
    // Don't fetch if no customer is selected (prevents unfiltered queries)
    if (!props?.customer?._id) {
      return
    }
    
    let filter = { archived: false }
    filter.customerIds = [props.customer._id]
    filter.surgeonId = props.user?.surgeon
    filter = { ...filter, ...props.msgfilter }
    
    props.fechactioncase({
      metadata: { current: 1, pageSize: 20 },
      filters: filter,
      sorter: { field: 'lastUpdated', order: 'descend' },
    })
    handleCaseView()
  }
  return (
    <>
      {!props.noBadge && (
        <Col>
          {<Badge dot color={color} style={{ marginLeft: 4 }} />}

          {/* <Badge 
                    className='notification-badge'
                    overlap="circular"
                    size="default" 
                    color={color}>
                    
                    <BellFilled size={'small'} style={{ color: color}}/>
                </Badge> */}
        </Col>
      )}
    </>
  )
}
const mapDispatchToProps = (dispatch) => {
  return {
    editcase: (data) => dispatch(editcase(data)),
    fechactioncase: (data) => dispatch(fechactioncase(data)),
    getMessageCase: (params) => dispatch(getMessageCase(params)),
    updateLastViewed: (params) => dispatch(updateLastViewed(params)),
    isEventUpdated: (params) => dispatch(isEventUpdated(params)),
    getEvents: (params) => dispatch(getEvents(params)),
    getDiffs: (params) => dispatch(getDifference(params)),
    isNewActionCase: (customer, surgeonId, companyId) =>
      dispatch(isNewActionCase(customer, surgeonId, companyId)),
  }
}
const mapStateToProps = (state) => {
  return {
    user: state.profile.user,
    msgfilter: state.message.filter,
    actionCasefilters: state.actioncase.filters,
    customer: state.profile.customer,
    company: state.profile.company,
    // surgerytype: state.event.surgerytype,
    // isUpdated: state.event.isUpdated,
    isNew: state.message.isNew,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationBell)
